export default (path: number[]) => {
  const number = path.filter((value: any) => value).join('.');

  return number ? `${number}.` : '';
};
